import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AlertCircle, ChevronRight, Home, ArrowLeft } from 'lucide-react';
import './ModulePlaceholder.css';

const ModulePlaceholder = ({ title, description }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const pageTitle = title || location.pathname.split('/').pop().replace(/-/g, ' ').toUpperCase();

  return (
    <div className="placeholder-container fade-in">
      <div className="placeholder-breadcrumb">
        <Home size={14} />
        <ChevronRight size={14} />
        <span>Configuraciones</span>
        <ChevronRight size={14} />
        <span className="current">{pageTitle}</span>
      </div>

      <div className="placeholder-header-actions">
        <button className="btn-back-v2" onClick={() => navigate(-1)}>
          <ArrowLeft size={18} /> Volver
        </button>
      </div>

      <div className="placeholder-card-v2">
        <div className="placeholder-icon-v2">
          <AlertCircle size={48} />
        </div>
        <h1>{pageTitle}</h1>
        <p className="placeholder-description-v2">{description || "Este módulo está siendo configurado con tus datos reales."}</p>
        
        <div className="placeholder-status-v2">
          <div className="pulse-dot"></div>
          <span>Módulo en Desarrollo - Paridad GDT v2.0</span>
        </div>

        <div className="placeholder-actions-v2">
          <button className="btn-primary-v2" onClick={() => navigate('/dashboard')}>
            IR AL PANEL PRINCIPAL
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModulePlaceholder;

